import type { HTMLAttributes, ReactNode } from "react";
import "./Card.css";

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  /** grey text under the title */
  description?: ReactNode;
  /** buttons on the right of the header */
  actions?: ReactNode;
  /** "section" (default) or "div" */
  as?: "section" | "div";
  className?: string;
  children?: ReactNode;
}

/**
 * White box for a page section.
 * Example: <Card title="Personal details" actions={<Button>Edit</Button>}>…</Card>
 */
const Card = ({
  title,
  description,
  actions,
  as: Tag = "section",
  className = "",
  children,
  ...rest
}: CardProps) => (
  <Tag className={`ds-card ${className}`.trim()} {...rest}>
    {(title || description || actions) && (
      <div className="ds-card__head">
        <div>
          {title && <h2 className="ds-card__title">{title}</h2>}
          {description && <p className="ds-card__text">{description}</p>}
        </div>
        {actions && <div className="ds-card__actions">{actions}</div>}
      </div>
    )}
    {children}
  </Tag>
);

export default Card;
